export const algorithmTypes = [
  {
    id: 1,
    name: 'invoiceRecognition',
    value: 'Invoice recognition',
    icon: 'euro',
    flowValue: 'Invoice flows',
    type: 'invoice',
    demoAction: 'Upload invoices',
    overviewDescription:
      'The Invoice Recognition algorithm of the Dokapi Recognition can detect more than 15 different fields on digital and scanned invoices.',
  },
  {
    id: 13,
    name: 'invoiceRecognitionPaddle',
    value: 'IR PADDLE',
    icon: 'trophy',
    flowValue: 'Invoice flows',
    type: 'invoice',
    demoAction: 'Upload invoices',
    overviewDescription:
      'The Invoice Recognition algorithm of the Dokapi Recognition can detect more than 15 different fields on digital and scanned invoices.',
  },
  {
    id: 10,
    name: 'receiptRecognition',
    value: 'Receipt recognition',
    icon: 'euro',
    flowValue: 'Receipt flows',
    type: 'receipt',
    demoAction: 'Upload receipts',
    overviewDescription:
      'The Receipt Recognition algorithm of the Dokapi Recognition can detect more than 15 different fields on digital and scanned receipts.',
  },
  {
    id: 3,
    name: 'invoiceRecognitionDeliveryHeroEN',
    value: 'Invoice recognition (DH EN)',
    icon: 'euro',
    flowValue: 'Invoice flows',
    type: 'invoice',
    demoAction: 'Upload invoices',
    overviewDescription:
      'The Invoice Recognition Delivery Hero EN algorithm of the Dokapi Recognition can detect more than 15 different fields on digital and scanned invoices.',
  },
  {
    id: 2,
    name: 'keywordDetection',
    value: 'Keyword Detection',
    icon: 'file-search',
    flowValue: 'Keyword flows',
    type: 'keyword',
    demoAction: 'Upload documents',
    overviewDescription:
      'The Keyword Detection algorithm of the Dokapi Recognition can detect more than 15 different fields on digital and scanned invoices.',
  },
  {
    id: 4,
    name: 'documentClassification',
    value: 'Document Classification',
    icon: 'file-search',
    flowValue: 'Classification flows',
    type: 'classification',
    demoAction: 'Upload documents',
    overviewDescription: '',
  },
  {
    id: 5,
    name: 'documentClassificationCnn',
    value: 'Thumbnail Classification',
    icon: 'file-search',
    flowValue: 'Classification flows',
    type: 'classification',
    demoAction: 'Upload documents',
    overviewDescription: '',
  },
  {
    id: 6,
    name: 'tableDetection',
    value: 'Table Detection',
    icon: 'euro',
    flowValue: 'Invoice flows',
    type: 'invoice',
    demoAction: 'Upload documents',
    overviewDescription: '',
  },
  {
    id: 8,
    name: 'invoiceRecognitionDeliveryHeroDE',
    value: 'Invoice recognition (DH DE)',
    icon: 'euro',
    flowValue: 'Invoice flows',
    type: 'invoice',
    demoAction: 'Upload invoices',
    overviewDescription: '',
  },
  {
    id: 7,
    name: 'pageClassification',
    value: 'Page Classification',
    icon: 'file-search',
    flowValue: 'Classification flows',
    type: 'classification',
    demoAction: 'Upload documents',
    overviewDescription: '',
  },
  {
    id: 9,
    name: 'multiflow',
    value: 'Multi-Model flows',
    icon: 'file-search',
    flowValue: 'Multi-Model flows',
    type: 'multiflow',
    demoAction: 'Upload documents',
    overviewDescription: '',
  },
  {
    id: 11,
    name: 'documentSplitter',
    value: 'Document Splitter',
    icon: 'scissor',
    flowValue: '',
    type: 'splitter',
    demoAction: 'Upload documents',
    overviewDescription: '',
  },
  {
    id: 12,
    name: 'contentMatcher',
    value: 'Content Matcher',
    icon: 'diff',
    flowValue: '',
    type: 'matcher',
    demoAction: 'Upload documents',
    overviewDescription: '',
  },
  {
    id: 15,
    name: 'tableExtraction',
    value: 'Table Extraction',
    icon: 'euro',
    flowValue: 'Invoice flows',
    type: 'invoice-table',
    demoAction: 'Upload documents',
    overviewDescription: '',
  },
];
